'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import DefaultErrorFallback from '@/components/internal/DefaultErrorFallback';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTags({
        category: 'errorBoundary',
        pathToFile: 'src/app/global-error.tsx',
      });

      scope.setLevel('error');

      Sentry.captureMessage('Unhandled error: ' + error.message);
    });
  }, [error]);

  return (
    <html>
      <body>
        <DefaultErrorFallback />
      </body>
    </html>
  );
}
